import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const anim = (i: number) => ({
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-40px'
  },
  transition: {
    duration: 0.3,
    delay: i * 0.08,
    ease: 'easeOut' as const
  }
});
interface HowItWorksProps {
  onStartQuiz: () => void;
}
export function HowItWorks({
  onStartQuiz
}: HowItWorksProps) {
  const steps = [{
    num: '01',
    title: 'Respondes el test',
    desc: 'Cuéntanos sobre tus hábitos, horarios y objetivos. Tarda 3 minutos. Es 100% gratuito.'
  }, {
    num: '02',
    title: 'Te conectamos',
    desc: 'Analizamos tus respuestas y te asignamos el nutriólogo certificado que mejor encaja contigo.'
  }, {
    num: '03',
    title: 'Empiezas tu plan',
    desc: 'Recibes tu plan de alimentación personalizado y acompañamiento continuo por videollamada.'
  }];
  return <section id="cómo-funciona" className="relative w-full bg-primary py-12 md:py-16 lg:py-20 border-y border-text-primary/5" data-id="element-112">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-[72px]" data-id="element-113">
        <div className="text-center mb-10 lg:mb-16" data-id="element-114">
          <h2 className="font-serif text-[28px] md:text-[42px] text-text-primary" data-id="element-115">
            Tres pasos. Tu plan personalizado.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-0" data-id="element-116">
          {steps.map((step, index) => <motion.div key={index} {...anim(index)} className={`flex flex-col px-0 md:px-10 ${index !== 0 ? 'md:border-l border-text-primary/10' : ''}`} data-id="element-117">
              <span className="font-serif text-[48px] md:text-[56px] font-medium text-accent leading-none mb-4" data-id="element-118">
                {step.num}
              </span>
              <h3 className="font-sans text-[16px] font-bold text-text-primary mb-2" data-id="element-119">
                {step.title}
              </h3>
              <p className="font-sans text-[14px] font-light text-text-secondary leading-[1.6]" data-id="element-120">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div {...anim(3)} className="mt-12 text-center flex flex-col items-center" data-id="element-121">
          <motion.button whileTap={{
          scale: 0.96
        }} className="w-full sm:w-auto bg-accent text-white uppercase text-[14px] font-bold tracking-wide py-4 px-8 rounded-full min-h-[52px] shadow-md inline-flex items-center justify-center space-x-2 hover:bg-accent/90 transition-all" data-id="element-122"> onClick={onStartQuiz}
            <span data-id="element-123">Empezar mi evaluación gratuita →</span>
          </motion.button>
          <p className="text-[12px] text-text-secondary mt-3" data-id="element-124">
            Sin compromiso · No pedimos tarjeta
          </p>
        </motion.div>
      </div>
    </section>;
}